module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAAJFBMVEVBiNBBiNBBiNBBiNDt8POsyeZIjNHm7PLQ3u2Cr91emtazzed3gjPZAAAAA3RSTlPmSklSjzZ3AAAAPUlEQVQY02NQMIYCJgZmGNOAwRgOqMQ0TYYzTboQTPfJUKaLi4trMpzpshldFKEWYQLCXModiex5ARiTEQBgsjZ6irDZfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_after_hover.png
// module id = +f8R
// module chunks = 9